import type { Component } from 'vue';
import {
  Avatar,
  Box,
  Document,
  HomeFilled,
  List,
  Message,
  Notebook,
  Odometer,
  Star,
  User
} from '@element-plus/icons-vue';

export interface AdminMenuItem {
  path: string;
  title: string;
  icon: Component;
  /** 未设置表示始终可见（如工作台） */
  moduleCode?: string;
  sortOrder: number;
}

export const ADMIN_MENU_ITEMS: AdminMenuItem[] = [
  { path: '/admin/dashboard', title: '工作台', icon: Odometer, sortOrder: 0 },
  { path: '/admin/routes', title: '路由管理', icon: List, moduleCode: 'cms:route', sortOrder: 10 },
  { path: '/admin/home', title: '首页管理', icon: HomeFilled, moduleCode: 'cms:homepage', sortOrder: 20 },
  { path: '/admin/products', title: '产品管理', icon: Box, moduleCode: 'cms:product', sortOrder: 30 },
  { path: '/admin/solutions', title: '解决方案管理', icon: Document, moduleCode: 'cms:solution', sortOrder: 40 },
  { path: '/admin/cases', title: '成功案例管理', icon: Star, moduleCode: 'cms:success-case', sortOrder: 50 },
  { path: '/admin/jobs', title: '人才招聘管理', icon: User, moduleCode: 'cms:recruitment', sortOrder: 60 },
  { path: '/admin/messages', title: '留言管理', icon: Message, moduleCode: 'cms:guestbook', sortOrder: 70 },
  { path: '/admin/news', title: '新闻管理', icon: Notebook, moduleCode: 'cms:news', sortOrder: 80 },
  { path: '/admin/users', title: '人员管理', icon: Avatar, moduleCode: 'system:user', sortOrder: 910 }
];

export const ADMIN_ROUTE_MODULE_MAP: Record<string, string> = Object.fromEntries(
  ADMIN_MENU_ITEMS.filter((item) => item.moduleCode).map((item) => [item.path, item.moduleCode!])
);
